var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group-head" }, [
    _c("div", { class: ["input-group-head__label", { large: _vm.large }] }, [
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
    ]),
    !!_vm.error
      ? _c("div", { staticClass: "input-group-head__error error" }, [
          _vm._v("\n    " + _vm._s(_vm.error) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }